import {ResetStyle} from '~/common/FabricInvitation/EventCreateDesign/components/CardEditor/actions/ResetStyle/ResetStyle';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {CloseLineIcon} from '~library/svg/CloseLineIcon';

import './ContentBase.sass';

export const ContentBaseHeader = ({
  onResetClick,
  resetDataQaId,
  style,
  title,
  hideResetButton = false,
  onCloseClick,
  closeDataQaId,
}) => (
  <div className="content_base__header">
    {!hideResetButton && (
      <ResetStyle
        label="Reset"
        style={style}
        onResetClick={onResetClick}
        dataQaId={resetDataQaId}
      />
    )}
    <div className="content_base__header__title">
      <Typography as="h1" variant="paragraph4" size="medium" color="pebble">
        {title}
      </Typography>
    </div>
    <Button
      variant="transparent"
      className="content_base__header__close_btn"
      onClick={onCloseClick}
      data-qa-id={closeDataQaId}
      data-impression-tracking="true"
      ariaLabel="Close"
      type="button"
    >
      <CloseLineIcon ratio={0.75} />
    </Button>
  </div>
);

export const ContentBase = ({
  title,
  children,
  onCloseClick,
  bodyStyle = {},
  noBodyPadding,
  visible,
  style,
  onResetClick,
  resetDataQaId,
  closeDataQaId,
  hideResetButton = false,
}) =>
  visible && (
    <div className="content_base">
      <ContentBaseHeader
        onResetClick={onResetClick}
        resetDataQaId={resetDataQaId}
        style={style}
        title={title}
        hideResetButton={hideResetButton}
        onCloseClick={onCloseClick}
        closeDataQaId={closeDataQaId}
      />
      <div
        className={`content_base__body ${noBodyPadding ? 'content_base__body--no-padding' : ''}`}
        style={bodyStyle}
      >
        {children}
      </div>
    </div>
  );
